import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { roleAllowedPaths, roleDefaultRoute } from 'src/constants';

function AuthGuard({ children }) {
  const account = useSelector((state) => state.account);
  const location = useLocation();

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  const roleValue = account.user?.roles[0]?.roleValue;
  const allowedPaths = roleAllowedPaths[roleValue];

  if (
    allowedPaths
    && !allowedPaths.some((path) => location.pathname.startsWith(path))
  ) {
    return <Redirect to={roleDefaultRoute[roleValue] || allowedPaths[0]} />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
